var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-tags"},[_c('div',{},_vm._l((_vm.tags),function(tag,index){return _c('a',{key:index},[_c('span',{staticClass:"badge badge-default"},[_vm._v(" "+_vm._s(tag.text)+" ")]),_vm._v("  ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }